import React, {useState} from 'react';
import TemplateDefault from "../../../components/template-default";
import Card from "../../../components/card";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import attendancesService from "../../../services/attendances-service";
import Button from "../../../components/button";
import InputText from "../../../components/input-text";
import InputForm from "../../../components/input-form";
import SelectComponent from "../../../components/select-component";
import OrdersTable from "../components/orders-table";
import moment from "moment";
import {toast} from "react-toastify";
import {AlertMessage} from "../../../utils/alert-message";

const initialState = {
    date_initial: moment().format("DD/MM/YYYY HH:mm"),
    status: "Aberto",
    product: null,
    problem: null
}

const AttendanceForm = () => {
    const {id} = useParams();
    const [searchParams] = useSearchParams();

    const [state, setState] = useState(initialState);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const {isError} = useQuery({
        queryFn: () => attendancesService.get(id, searchParams.get("type")).then((data) => {
            const {date_initial, dt_initial, status, product, problem, orders} = data;

            setState({
                date_initial: moment(date_initial ?? dt_initial).format("DD/MM/YYYY HH:mm"),
                status,
                product,
                problem,
                orders
            })

            return data;
        }),
        queryKey: ['hardware-attendances', {id}],
        enabled: !!id && !!searchParams.get("type"),
        retry: 0
    });

    if (isError) navigate("/404");

    const {data: products} = useQuery({
        queryFn: () => attendancesService.getProducts(),
        queryKey: ['products']
    });

    const submit = () => {
        setIsLoading(true);

        const formData = new FormData();

        const product_id = state.product?.value ?? null

        formData.append("date_initial", state.date_initial);
        formData.append("product_id", product_id);
        formData.append("problem", state.problem);
        formData.append("type", product_id === -1 ? "software" : "infra");

        attendancesService.create(formData)
            .then(({data}) => {
                toast.success("Salvo com sucesso.");
                navigate(`/attendances/form/${data.id}?type=${data.type}`);
            })
            .catch((err) => {
                const {data: {message}} = err.response;
                toast.error(AlertMessage[message] ?? "Não foi possível salvar");
            })
            .finally(() => setIsLoading(false));
    }

    return (
        <TemplateDefault title="Cadastro de chamados" isLoading={isLoading}>
            <Card>
                <div className="grid lg:grid-cols-12 gap-4 col-span-2">
                    <InputForm id="date_initial" value={state.date_initial} label="Abertura" disabled col="col-span-12 lg:col-span-3"/>

                    <InputForm id="status" value={state.status} label="Status" disabled col="col-span-12 lg:col-span-3"/>

                    <div className="col-span-12 lg:col-span-6">
                        <SelectComponent
                            instanceId="product"
                            label="Produto (Localização)"
                            options={products}
                            value={state.product}
                            onChange={(value) => setState(prev => ({...prev, product: value}))}
                            name="product"
                            isDisabled={!!id}
                        />
                    </div>

                    <InputText
                        id="problem" name="info" value={state.problem ?? ""}
                        onChange={({target: {value}}) => setState(prev => ({...prev, problem: value}))}
                        label="Requisição" col="col-span-12"
                        disabled={!!id}
                    />
                </div>
            </Card>

            {!!state?.orders?.length && <OrdersTable orders={state.orders}/>}

            <Card wrapperClass="mt-5">
                <div className="flex justify-end gap-3">
                    <Button target="warning" onClick={() => navigate("/attendances")}>
                        Cancelar
                    </Button>

                    {
                        !id &&
                        <Button target="success" onClick={submit}>
                            Salvar
                        </Button>
                    }
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default AttendanceForm;